import API_ENDPOINTS from 'services/urls';
import axiosInstance from 'ns_libs/nsAxios';
import { useMutation } from '@tanstack/react-query';

interface SendPasswordResetEmailParams {
    email: string;
    redirect_url?: string;
}

interface SendPasswordResetEmailResponse {
    success: boolean;
}

const sendPasswordResetEmail = async (
    params: SendPasswordResetEmailParams,
): Promise<SendPasswordResetEmailResponse> => {
    const response = await axiosInstance.post(
        API_ENDPOINTS.SIGNUP.SEND_PASSWORD_RESET_EMAIL,
        {
            email: params.email,
            redirectUrl: params.redirect_url,
        },
    );
    return response.data;
};

export const useSendPasswordResetEmail = () => useMutation({
    mutationFn: sendPasswordResetEmail,
});

export default useSendPasswordResetEmail;
